<div class="row page-header">
    <div class="col-12">
        <h1>Material Analytics <small>View and analyize the use of materials</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar" style="margin-top: 15px">
                <div class="col-12">
                    <form class="form-inline">
                        <div class="input-header-group">
                            <span class="input-header">Start Date</span>
                            <wj-input-date
                                [(ngModel)]="startDate"
                                (ngModelChange)="refresh()"
                                name="startDate"
                                style="width: 125px; height: 32px; margin-top: 4px"
                            ></wj-input-date>
                        </div>
                        <div class="input-header-group">
                            <span class="input-header">End Date</span>
                            <wj-input-date
                                [(ngModel)]="endDate"
                                (ngModelChange)="refresh()"
                                name="endDate"
                                style="width: 125px; height: 32px; margin-top: 4px"
                            ></wj-input-date>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Job Summary</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="jobGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridJob" [name]="'Fuel Totals'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="jobGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridJob"
                                    #gridJob
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="jobGrid.initialize(gridJob)"
                                    [itemsSource]="jobGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="450"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Material (Tons)'"
                                        [binding]="'material'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Concrete (Yards)'"
                                        [binding]="'concrete'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Flowfill (Yards)'"
                                        [binding]="'flowfill'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridJob"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="4" [destroyOnHide]="false">
            <a ngbNavLink>Job Summary By Vendor</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="jobVendorGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridJobVendor" [name]="'Fuel Totals'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="jobVendorGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridJobVendor"
                                    #gridJobVendor
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="jobVendorGrid.initialize(gridJobVendor)"
                                    [itemsSource]="jobVendorGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="450"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Vendor'" [binding]="'vendorName'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Material (Tons)'"
                                        [binding]="'material'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Concrete (Yards)'"
                                        [binding]="'concrete'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Flowfill (Yards)'"
                                        [binding]="'flowfill'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridJobVendor"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Consumption</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="usageGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridUsage" [name]="'Fuel Totals'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="usageGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridUsage"
                                    #gridUsage
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="usageGrid.initialize(gridUsage)"
                                    [itemsSource]="usageGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="450"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="200"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Material'" [binding]="'material'" [width]="300"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Yards'" [binding]="'yards'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Yards Record Count'"
                                        [binding]="'yardsRecordCount'"
                                        [width]="100"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Avg Yards'" [binding]="'avgYards'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Tons'" [binding]="'tons'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Tons Record Count'"
                                        [binding]="'tonsRecordCount'"
                                        [width]="100"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Avg Tons'" [binding]="'avgTons'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Loads'" [binding]="'loads'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Loads Record Count'"
                                        [binding]="'loadsRecordCount'"
                                        [width]="100"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Load Tons Based on Avg'"
                                        [binding]="'loadTonsBasedOnAvg'"
                                        [width]="180"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Estimated Total Tons'"
                                        [binding]="'estimatedTotalTons'"
                                        [width]="180"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridUsage"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Trips</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="tripsGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridTrips" [name]="'Fuel Totals'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="tripsGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridTrips"
                                    #gridTrips
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="tripsGrid.initialize(gridTrips)"
                                    [itemsSource]="tripsGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="450"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="200"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Material'" [binding]="'material'" [width]="300"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Trips'" [binding]="'trips'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Tickets'" [binding]="'tickets'" [width]="'*'"></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridTrips"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
